import {oldServerApi} from "./RestService";


const pingService = oldServerApi.injectEndpoints({
    endpoints: builder => ({
        ping: builder.query<string, void>({
            query: () => ({
                url: '/',
                responseHandler: "text"
            })
        })
    })
})

export const {
    usePingQuery, useLazyPingQuery
} = pingService